import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=7e61480a&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61480a",
  null
  
)

export default component.exports